import React from "react";
import PropTypes from "prop-types";

function PromoProductResult({ gid }) {
  return <div>PromoProduct: {JSON.stringify(gid)}</div>;
}

PromoProductResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default PromoProductResult;
